
import { IntegrationCategory } from "./types";

export function getIntegrationCategoryName(category: IntegrationCategory): string {
	const map: Record<IntegrationCategory, string> = {
		PAYMENT_GATEWAY: 'Pasarelas de pago',
		SHIPPING_CARRIER: 'Envíos',
		MARKETPLACE: 'Marketplaces',
		EMAIL_MARKETING: 'Email marketing',
		ANALYTICS: 'Medición y análisis',
		ACCOUNTING: 'Contabilidad',
		SOCIAL_MEDIA: 'Redes sociales',
		OTHER: 'Otros',
	};

	return map[category] ?? 'Otro';
}